import { Vue } from "vue-property-decorator";
import { DirectiveOptions } from "vue";

/**
 * スクロール位置を最下段に移動させるディレクティブ
 *
 * スクロールが表示される要素の高さを取得して、スクロール位置をその位置まで移動させる
 * 遅延読み込み(img要素)等がある場合、スクロールの高さが可変になってしまうためズレが生じる
 * そのため、img要素を内包する場合は高さを固定にすること
 */
const BottomScroll: DirectiveOptions = {
  componentUpdated(el) {
    const _el = el;

    Vue.nextTick(() => {
      _el.scrollTop = _el.scrollHeight;
    });
  }
};

export default BottomScroll;
